import { API } from '../Api';

// "Thử thách donate": streamer đặt mục tiêu theo hạng (Top) hoặc theo đích (Race),
// người donate nhiều nhất / về đích trước được vinh danh; phần thưởng là lời hứa của streamer,
// Cab không trả thay. Sự kiện Cab (Scope Platform, quản trị riêng) mới là nơi hệ thống tự trao
// vật phẩm Cửa hàng (Nametag/AvatarEffect) và/hoặc Ca đào cho người thắng.
// Khác "Mục tiêu donate" (donate-goal) ở chỗ có bảng xếp hạng người donate + quà cho người thắng.

export type ChallengeMode = 'Top' | 'Race';
export type ChallengeStatus = 'Scheduled' | 'Running' | 'Finalized' | 'Cancelled';

export interface ChallengeEntry {
  rank: number;
  displayName: string;
  userName: string | null;
  isAnonymous: boolean;
  amount: number;
  reachedAt: string | null;
}

export interface ChallengeWinner extends ChallengeEntry {
  rewardStatus: string;
  rewardError?: string | null;
}

export interface ChallengeReward {
  rankFrom: number;
  rankTo: number;
  storeItemCode: string | null;
  storeItemName: string | null;
  storeItemType: string | null;
  durationDays: number | null;
  minedCa: number | null;
}

export interface DonateChallenge {
  exists: boolean;
  id: string;
  scope: 'Creator' | 'Platform';
  creatorId: string | null;
  title: string;
  description: string | null;
  mode: ChallengeMode;
  targetAmount: number | null;
  winnerCount: number;
  rewardText: string | null;
  startAt: string;
  endAt: string;
  status: ChallengeStatus;
  finalizedAt: string | null;
  serverNow: string;
  hasCountedDonations: boolean;
  leaderboard: ChallengeEntry[];
  winners: ChallengeWinner[];
  rewards: ChallengeReward[];
}

export interface MyDonateChallenge {
  current: DonateChallenge | null;
  recent: DonateChallenge[];
}

export interface SaveCreatorChallengeBody {
  title: string;
  mode: ChallengeMode;
  targetAmount?: number | null;
  winnerCount: number;
  rewardText: string;
  startAt?: string | null;
  endAt: string;
}

const BASE = '/v1/payment-service/donate-challenge';

export const getMyDonateChallenge = () =>
  API.get<MyDonateChallenge>(`${BASE}/me`).then((r) => r.data);

export const createDonateChallenge = (body: SaveCreatorChallengeBody) =>
  API.post<DonateChallenge>(BASE, body).then((r) => r.data);

export const updateDonateChallenge = (id: string, body: SaveCreatorChallengeBody) =>
  API.put<DonateChallenge>(`${BASE}/${id}`, body).then((r) => r.data);

export const cancelDonateChallenge = (id: string) =>
  API.post<DonateChallenge>(`${BASE}/${id}/cancel`).then((r) => r.data);

// Công khai — overlay OBS + trang sự kiện gọi được mà không cần đăng nhập.
export const getPublicCreatorChallenge = (userId: string) =>
  API.get<DonateChallenge>('/v1/payment-service/public/creator-donate-challenge', {
    params: { userId },
  }).then((r) => r.data);

export const getPublicDonateEvents = () =>
  API.get<DonateChallenge[]>('/v1/payment-service/public/donate-events').then((r) => r.data);

export const getPublicDonateEvent = (id: string) =>
  API.get<DonateChallenge>(`/v1/payment-service/public/donate-events/${id}`).then((r) => r.data);
